import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicDelaisRemboursement = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Remboursements', link: '/topics/paiement/remboursements'},
    { label: topic.title, link: topic.link},
  ];

  // <a target='_blank' className="link" href="https://wodzone.fr">https://wodzone.fr</a>


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Si vous avez<a target='_blank' className="link" href="#">droit à un remboursement,</a> les organisateurs l'envoient dès que vous annulez,
              mais le délai de réception des fonds dépend de votre banque ou de votre établissement financier. 
              Ce délai varie en fonction de votre mode de paiement, de la date du paiement et de votre lieu de résidence.
            </p>
            <p className="help-text">
              Pour suivre votre remboursment, consulter compte bancaire. Si passé 15 jours ouvrés, veuillez
              <a target='_blank' className="link" href='/topics/inscription/34'>contacter</a>votre organisateur qui fera le necessaire pour vous aider.
            </p>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicDelaisRemboursement